module.exports = __webpack_public_path__ + "img/list_9_zh.e56521dd.png";